export default __webpack_public_path__ + "credit-card.png";